
















import { defineComponent } from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import HeaderLogo from "~/components/Header/HeaderLogo.vue";
import HeaderNavigation from "~/components/Header/Navigation/HeaderNavigationNew.vue";
import HeaderSearch from "~/components/Header/SearchBar/HeaderSearch.vue";
import SearchPopup from "~/components/Header/SearchBar/SearchPopup.vue";
import HeaderStore from "~/components/Header/HeaderStore.vue";
import HeaderAcount from "~/components/Header/HeaderAcount.vue";
import HeaderCart from "~/components/Header/HeaderCart.vue";

export default defineComponent({
  components: {
    HeaderLogo,
    HeaderNavigation,
    HeaderSearch,
    SearchPopup,
    HeaderStore,
    HeaderAcount,
    HeaderCart,
  },
  setup() {
    const { isSearchPopupOpen, toggleSearchPopup } = useUiState();

    return {
      isSearchPopupOpen,
      toggleSearchPopup
    };
  }
});
